import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import Footer from "../components/Footer";
import AnimatedPage from "../components/AnimatedPage";

function Invite() {
    const [profile, setProfile] = useState(null);
    const [isShow, setShow] = useState(false);
    const [daily, setDaily] = useState(null);
    const [popup, setPopup] = useState(null);
    
    // State cho Tab giao diện
    const [activeTab, setActiveTab] = useState("TRANG_CHU");

    const navigate = useNavigate();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    const handleBackClick = () => {
        navigate(-1);
    };

    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
    }

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                setProfile(res.data.data);
            })
            .catch(() => localStorage.removeItem("user"));

        axios.post(`${process.env.REACT_APP_API_URL}/auth/getCustomer`, { code: "" })
            .then((res) => {
                setDaily(res.data.data);
            });
    }, []);

    const handleCopyClick = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text).then(() => {
            swal("Thành công", "Sao chép thành công!", "success");
        }).catch(() => {
            const tempInput = document.createElement("input");
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
            swal("Thành công", "Sao chép thành công!", "success");
        });
    };

    const thongkeAff = (username) => {
        axios.post(`${process.env.REACT_APP_API_URL}/auth/thongkeaff`, { username })
            .then((res) => {
                setPopup(res.data.data);
                setShow(true);
            })
            .catch(() => swal("Chưa có dữ liệu", "Người chơi này chưa tham gia trò chơi nào", "info"));
    };

    const chuyenDoi = () => {
        if (!profile?.moneyaff || profile.moneyaff < 10000) {
            return swal("Chú ý", "Số tiền hoa hồng tối thiểu để chuyển đổi là 10.000", "warning");
        }
        axios.post(`${process.env.REACT_APP_API_URL}/auth/chuyendoiaff`, {})
            .then(() => {
                swal("Thành công", "Đã chuyển đổi toàn bộ hoa hồng thành số dư tài khoản", "success")
                .then(() => window.location.reload());
            })
            .catch((err) => swal("Thông báo", err.response?.data?.message || "Đã có lỗi xảy ra!", "error"));
    };

    // Tạo Link mời
    const inviteLink = profile?.code ? `${window.location.origin}/?id=${profile.code}` : window.location.origin;

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#f4f6f8", overflow: "hidden" }}>
            <style dangerouslySetInnerHTML={{__html: `
                * { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; box-sizing: border-box; }
                body { background-color: #f4f6f8; margin: 0; padding: 0; color: #333; }
                
                .i-app-main {
                    position: fixed; top: 0; bottom: 60px; left: 0; right: 0; 
                    margin: 0 auto; max-width: 540px; background: #f4f6f8; 
                    display: flex; flex-direction: column; overflow-y: auto; overflow-x: hidden;
                    z-index: 10;
                }
                .i-app-main::-webkit-scrollbar { display: none; }
                .i-app-main { -ms-overflow-style: none; scrollbar-width: none; }

                /* HEADER */
                .i-header {
                    display: flex; align-items: center; justify-content: space-between;
                    height: 50px; padding: 0 15px; border-bottom: 1px solid #f0f0f0; background: #fff;
                    position: sticky; top: 0; z-index: 50;
                }
                .i-header-back { cursor: pointer; display: flex; align-items: center; justify-content: center; }
                .i-header-title { font-size: 16px; font-weight: 700; color: #333; flex: 1; text-align: center; }
                .i-header-right { cursor: pointer; color: #4caf50; font-size: 12px; font-weight: 500; display: flex; flex-direction: column; text-align: right; line-height: 1.2;}

                /* TABS */
                .i-tabs-wrap { background: #fff; border-bottom: 1px solid #e0e0e0; }
                .i-tabs { display: flex; overflow-x: auto; white-space: nowrap; padding: 0 10px; }
                .i-tabs::-webkit-scrollbar { display: none; }
                .i-tab {
                    padding: 12px 15px; font-size: 14px; font-weight: 500; color: #555;
                    cursor: pointer; position: relative; transition: 0.2s;
                }
                .i-tab.active { color: #4caf50; font-weight: 600; }
                .i-tab.active::after {
                    content: ''; position: absolute; bottom: 0; left: 15px; right: 15px;
                    height: 3px; background: #4caf50; border-radius: 3px 3px 0 0;
                }

                /* CONTENT */
                .i-content { padding: 15px; }
                
                /* BANNER */
                .i-banner {
                    background: linear-gradient(90deg, #dff6e3 0%, #a3e4b0 100%);
                    border-radius: 12px; padding: 20px 15px; position: relative;
                    margin-bottom: 15px; overflow: hidden; display: flex; align-items: center; justify-content: space-between;
                    border: 1px solid #c8ecd0;
                }
                .i-banner-tag {
                    position: absolute; top: 0; left: 15px; background: #333; color: #fff;
                    padding: 4px 10px; border-radius: 0 0 8px 8px; font-size: 11px; font-weight: bold;
                }
                .i-banner-hot {
                    position: absolute; top: 0; right: 0; background: #e74c3c; color: #fff;
                    padding: 3px 20px; font-size: 10px; font-weight: bold; transform: rotate(45deg) translate(20px, -15px);
                }
                .i-banner-text { width: 60%; }
                .i-banner-title { font-size: 18px; font-weight: 900; color: #1f8a3e; line-height: 1.3; text-transform: uppercase; text-shadow: 1px 1px 0px #fff;}
                .i-banner-img { width: 40%; text-align: right; }
                .i-banner-img svg { max-width: 100%; height: auto; }

                /* CARD GENERAL */
                .i-card { background: #fff; border-radius: 10px; padding: 15px; margin-bottom: 15px; box-shadow: 0 1px 5px rgba(0,0,0,0.03); }

                /* ACCOUNT INFO */
                .i-info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 15px 10px; font-size: 13px; color: #666; }
                .i-info-val { font-size: 14px; color: #333; font-weight: 500; margin-top: 4px; display: flex; align-items: center; gap: 5px; }

                /* INVITE LINK */
                .i-invite-header { display: flex; justify-content: space-between; font-size: 14px; margin-bottom: 15px; align-items: center; }
                .i-invite-body { display: flex; gap: 15px; }
                .i-qr-col { width: 90px; flex-shrink: 0; text-align: center; }
                .i-qr-img { width: 90px; height: 90px; border: 1px solid #e0e0e0; border-radius: 6px; padding: 4px; background: #fff; margin-bottom: 8px;}
                .i-qr-btn { width: 100%; background: #4caf50; color: #fff; border: none; padding: 6px 0; font-size: 12px; border-radius: 4px; font-weight: bold; cursor: pointer; }
                
                .i-link-col { flex: 1; min-width: 0; }
                .i-link-input-wrap { display: flex; align-items: center; gap: 8px; margin-bottom: 15px;}
                .i-link-input {
                    flex: 1; padding: 10px; border: 1px solid #e0e0e0; border-radius: 6px; font-size: 13px;
                    color: #555; background: #fafafa; outline: none; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                }
                .i-copy-btn { color: #4caf50; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 5px;}
                
                .i-socials { display: flex; justify-content: space-between; text-align: center; font-size: 11px; color: #555; margin-top: 10px;}
                .i-social-icon { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 5px; color: #fff; font-size: 20px; }
                .bg-chia { background: #e0e0e0; color: #555; }
                .bg-fb { background: #1877f2; }
                .bg-tele { background: #229ED9; }
                .bg-wa { background: #25D366; }
                .bg-thread { background: #000000; }

                /* STATS */
                .i-stat-grid { display: grid; grid-template-columns: 1fr 1fr; }
                .i-stat-label { font-size: 13px; color: #666; margin-bottom: 5px; }
                .i-stat-val { font-size: 16px; font-weight: bold; }
                .text-orange { color: #f39c12; }

                /* REVENUE */
                .i-rev-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; }
                .i-rev-title { font-size: 15px; font-weight: bold; color: #333; }
                .i-rev-sub { font-size: 12px; color: #888; font-weight: normal;}
                .i-rev-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 15px 10px; margin-bottom: 20px;}
                .i-rev-grid .i-stat-val { font-size: 15px; font-weight: 500; color: #333; }
                .i-rev-grid .text-orange { color: #f39c12; font-weight: bold;}
                .i-receive-btn {
                    width: 100px; margin-left: auto; display: block; padding: 10px 0; border-radius: 6px; border: none;
                    background: #999; color: #fff; font-weight: bold; cursor: not-allowed; transition: 0.3s;
                }
                .i-receive-btn.active { background: #4caf50; cursor: pointer; box-shadow: 0 2px 6px rgba(76,175,80,0.3); }

                /* TABLE FOR DATA TAB */
                .t-table { width: 100%; border-collapse: collapse; font-size: 13px; text-align: center; }
                .t-table th { background: #f4f6f8; padding: 12px 5px; color: #555; font-weight: 600; border-bottom: 1px solid #eee; }
                .t-table td { padding: 12px 5px; border-bottom: 1px solid #eee; color: #333; }

                /* MODAL */
                .b-modal-overlay {
                    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.6); z-index: 9999;
                    display: flex; align-items: center; justify-content: center;
                }
                .b-modal-content {
                    background: #fff; width: 90%; max-width: 400px;
                    border-radius: 12px; padding: 20px;
                    position: relative; max-height: 80vh; overflow-y: auto;
                }
                .b-modal-close { position: absolute; top: 15px; right: 15px; cursor: pointer; color: #888; }
            `}} />

            <div className="i-app-main">
                <AnimatedPage>
                    {/* ===== HEADER ===== */}
                    <div className="i-header">
                        <div className="i-header-back" onClick={handleBackClick}>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#333"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
                        </div>
                        <div className="i-header-title">Giới Thiệu Bạn</div>
                        <div className="i-header-right">
                            <span>Chuyển sang</span>
                            <span>máy tính</span>
                        </div>
                    </div>

                    {/* ===== TABS ===== */}
                    <div className="i-tabs-wrap">
                        <div className="i-tabs">
                            <div className={`i-tab ${activeTab === "TRANG_CHU" ? "active" : ""}`} onClick={() => setActiveTab("TRANG_CHU")}>TRANG CHỦ</div>
                            <div className={`i-tab ${activeTab === "QUANG_BA" ? "active" : ""}`} onClick={() => setActiveTab("QUANG_BA")}>Quảng Bá Và Chia Sẻ</div>
                            <div className={`i-tab ${activeTab === "DU_LIEU" ? "active" : ""}`} onClick={() => setActiveTab("DU_LIEU")}>Dữ liệu</div>
                            <div className={`i-tab ${activeTab === "DOANH_THU" ? "active" : ""}`} onClick={() => setActiveTab("DOANH_THU")}>Doanh Thu Của Tôi</div>
                        </div>
                    </div>

                    {/* ===== TAB CONTENT ===== */}
                    <div className="i-content">
                        
                        {activeTab === "TRANG_CHU" && (
                            <>
                                {/* BANNER */}
                                <div className="i-banner">
                                    <div className="i-banner-tag">MÃ: {profile?.code || "GT200"}</div>
                                    <div className="i-banner-hot">HOT</div>
                                    <div className="i-banner-text">
                                        <div className="i-banner-title">
                                            GIỚI THIỆU BẠN BÈ<br/>
                                            <span style={{color: '#4caf50'}}>TẶNG NGAY 200K</span>
                                        </div>
                                    </div>
                                    <div className="i-banner-img">
                                        {/* Icon người dùng mô phỏng */}
                                        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="50" cy="50" r="45" fill="#e8f5e9" stroke="#4caf50" strokeWidth="4"/>
                                            <circle cx="50" cy="35" r="15" fill="#4caf50"/>
                                            <path d="M20 80C20 65 35 55 50 55C65 55 80 65 80 80" fill="#4caf50"/>
                                            <circle cx="75" cy="75" r="15" fill="#f39c12"/>
                                            <path d="M70 75H80M75 70V80" stroke="#fff" strokeWidth="3" strokeLinecap="round"/>
                                        </svg>
                                    </div>
                                </div>

                                {/* ACCOUNT INFO CARD */}
                                <div className="i-card">
                                    <div className="i-info-grid">
                                        <div>
                                            Tài khoản đại lý
                                            <div className="i-info-val">
                                                <svg viewBox="0 0 24 24" width="16" height="16" fill="#f39c12"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
                                                {profile?.username || "---"}
                                            </div>
                                        </div>
                                        <div>
                                            Cấp độ đại lý
                                            <div className="i-info-val" style={{color: '#4caf50'}}>
                                                <svg viewBox="0 0 24 24" width="16" height="16" fill="#4caf50"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
                                                Giới thiệu
                                            </div>
                                        </div>
                                        <div>
                                            Bội Số Kiểm Toán
                                            <div className="i-info-val">0.00</div>
                                        </div>
                                        <div>
                                            Ngày thanh toán
                                            <div className="i-info-val">{formatDate(profile?.createdAt) || "---"}</div>
                                        </div>
                                    </div>
                                </div>

                                {/* INVITE LINK CARD */}
                                <div className="i-card">
                                    <div className="i-invite-header">
                                        <span style={{fontWeight: 'bold'}}>Mời bạn bè</span>
                                        <span style={{color: '#666'}}>
                                            Mã mời của tôi: <b style={{color: '#333'}}>{profile?.code}</b>
                                            <svg onClick={() => handleCopyClick(profile?.code)} style={{marginLeft: '5px', cursor: 'pointer', verticalAlign: 'text-bottom'}} viewBox="0 0 24 24" width="16" height="16" fill="#4caf50"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg>
                                        </span>
                                    </div>
                                    <div className="i-invite-body">
                                        <div className="i-qr-col">
                                            {/* Tạo QR thật bằng API */}
                                            <img className="i-qr-img" src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(inviteLink)}`} alt="QR Code" />
                                            <button className="i-qr-btn">Lưu mã mời</button>
                                        </div>
                                        <div className="i-link-col">
                                            <div style={{fontSize: '12px', color: '#666', marginBottom: '5px'}}>Liên kết mời</div>
                                            <div className="i-link-input-wrap">
                                                <div className="i-link-input">{inviteLink}</div>
                                                <div className="i-copy-btn" onClick={() => handleCopyClick(inviteLink)}>
                                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg>
                                                </div>
                                            </div>
                                            
                                            <div className="i-socials">
                                                <div onClick={() => handleCopyClick(inviteLink)}>
                                                    <div className="i-social-icon bg-chia"><svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/></svg></div>
                                                    Chia
                                                </div>
                                                <div>
                                                    <div className="i-social-icon bg-fb"><svg viewBox="0 0 24 24" width="24" height="24" fill="#fff"><path d="M22.675 0h-21.35C.597 0 0 .597 0 1.325v21.351C0 23.403.597 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.31h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.323-.597 1.323-1.325V1.325C24 .597 23.403 0 22.675 0z"/></svg></div>
                                                    Facebook
                                                </div>
                                                <div>
                                                    <div className="i-social-icon bg-tele"><svg viewBox="0 0 24 24" width="20" height="20" fill="#fff"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.825 8.358l-1.939 9.07c-.145.642-.524.8-1.066.505l-2.946-2.17-1.42 1.368c-.157.157-.289.29-.594.29l.211-3.003 5.467-4.945c.238-.211-.052-.329-.369-.125l-6.757 4.24-2.91-.911c-.633-.198-.646-.633.131-.938l11.385-4.38c.528-.198 1.002.119.807 1.001z"/></svg></div>
                                                    Telegram
                                                </div>
                                                <div>
                                                    <div className="i-social-icon bg-wa"><svg viewBox="0 0 24 24" width="22" height="22" fill="#fff"><path d="M12.016 1.984C6.49 1.984 2 6.474 2 12c0 1.76.463 3.42 1.258 4.88L2.016 22l5.244-1.22A9.957 9.957 0 0 0 12.016 22c5.526 0 10.016-4.49 10.016-10.016S17.542 1.984 12.016 1.984zm5.556 14.542c-.23.644-1.34 1.242-1.854 1.342-.486.096-1.12.164-3.56-1.01-2.945-1.424-4.838-4.57-4.98-4.757-.14-.188-1.186-1.577-1.186-3.002 0-1.425.742-2.128 1.007-2.42.264-.29.574-.362.766-.362.19 0 .38.002.548.01.173.008.403-.066.628.472.235.564.8 1.954.872 2.103.07.148.118.324.02.51-.096.188-.146.305-.29.493-.146.188-.308.41-.44.574-.146.166-.305.348-.13.65.176.302.784 1.313 1.697 2.124 1.182 1.05 2.165 1.374 2.464 1.517.298.146.474.12.65-.058.174-.175.76-0.887.962-1.19.203-.304.405-.253.682-.148.277.106 1.758.828 2.058.977.3.148.502.222.574.347.072.126.072.732-.158 1.376z"/></svg></div>
                                                    WhatsApp
                                                </div>
                                                <div>
                                                    <div className="i-social-icon bg-thread"><svg viewBox="0 0 24 24" width="20" height="20" fill="#fff"><path d="M15.4 12c0 2-1.4 3.1-3.1 3.1-1.8 0-3.3-1.2-3.3-3s1.5-3.1 3.3-3.1c1.5 0 2.8 1.1 3.1 2.5h-1.6c-.3-.7-1-1.2-1.7-1.2-1 0-1.8.8-1.8 1.8 0 1 .8 1.8 1.8 1.8.8 0 1.4-.5 1.5-1.1h-2v-1.4h3.6c.1.3.1.5.1.8zM12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm7.6 10c0 4.2-3.4 7.6-7.6 7.6S4.4 16.2 4.4 12 7.8 4.4 12 4.4s7.6 3.4 7.6 7.6z"/></svg></div>
                                                    Thread
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* STATS SUMMARY CARD */}
                                <div className="i-card">
                                    <div className="i-stat-grid">
                                        <div>
                                            <div className="i-stat-label">Tích lũy</div>
                                            <div className="i-stat-val text-orange">{(profile?.moneyaff || 0).toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div>
                                            <div className="i-stat-label">Tổng số người được mời</div>
                                            <div className="i-stat-val">{daily ? daily.length : 0}</div>
                                        </div>
                                    </div>
                                </div>

                                {/* REVENUE DETAILS CARD */}
                                <div className="i-card">
                                    <div className="i-rev-header">
                                        <div>
                                            <div className="i-rev-title">Hoa Hồng Của Tôi <span className="i-rev-sub">(Lần thanh toán kế tiếp còn 1 ngày)</span></div>
                                        </div>
                                        <svg viewBox="0 0 24 24" width="20" height="20" fill="#999"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
                                    </div>
                                    
                                    <div className="i-rev-grid">
                                        <div>
                                            <div className="i-stat-label">Kết quả trực tiếp ngày hôm qua</div>
                                            <div className="i-stat-val">0.00</div>
                                        </div>
                                        <div>
                                            <div className="i-stat-label">Hoa hồng tích lũy</div>
                                            <div className="i-stat-val text-orange">{(profile?.moneyaff || 0).toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div>
                                            <div className="i-stat-label">Đã Hoàn Thành</div>
                                            <div className="i-stat-val">0.00</div>
                                        </div>
                                        <div>
                                            <div className="i-stat-label">Đang Chờ Nhận</div>
                                            <div className="i-stat-val text-orange">{(profile?.moneyaff || 0).toLocaleString("vi-VN")}</div>
                                        </div>
                                    </div>

                                    {/* Nút Nhận */}
                                    <button 
                                        className={`i-receive-btn ${profile?.moneyaff >= 10000 ? 'active' : ''}`}
                                        onClick={chuyenDoi}
                                        disabled={!profile?.moneyaff || profile.moneyaff < 10000}
                                    >
                                        Nhận
                                    </button>
                                </div>
                            </>
                        )}

                        {activeTab === "DU_LIEU" && (
                            <div className="i-card" style={{padding: '10px 0'}}>
                                <h3 style={{padding: '0 15px 10px', fontSize: '16px', fontWeight: 'bold', margin: '0', borderBottom: '1px solid #eee'}}>Báo cáo đại lý</h3>
                                <div style={{overflowX: 'auto'}}>
                                    {daily && daily.length > 0 ? (
                                        <table className="t-table">
                                            <thead>
                                                <tr>
                                                    <th>Tài khoản</th>
                                                    <th>Cược</th>
                                                    <th>Hoa hồng</th>
                                                    <th>Nhật ký</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {daily.map((user, idx) => (
                                                    user?.username !== profile?.username && (
                                                        <tr key={idx}>
                                                            <td>
                                                                <div style={{fontWeight: '600', color: '#2ba1d8'}}>{user?.username}</div>
                                                                <div style={{fontSize: '11px', color: '#888'}}>ID: {user?.iduser}</div>
                                                            </td>
                                                            <td>{(user?.totalbet + user?.totalbetapi)?.toLocaleString("vi-VN")}</td>
                                                            <td style={{color: '#e74c3c', fontWeight: '500'}}>{Number(user?.moneyforaff?.toFixed(0))?.toLocaleString("vi-VN")}</td>
                                                            <td>
                                                                <span style={{background: '#e3f2fd', color: '#2ba1d8', padding: '4px 10px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', fontWeight: 'bold'}} onClick={() => thongkeAff(user?.username)}>
                                                                    Kiểm tra
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div style={{ padding: "30px 0", textAlign: 'center', color: '#888' }}>Chưa có dữ liệu người dùng</div>
                                    )}
                                </div>
                            </div>
                        )}

                        {(activeTab === "QUANG_BA" || activeTab === "DOANH_THU") && (
                            <div className="i-card" style={{textAlign: 'center', padding: '40px 15px', color: '#888'}}>
                                Đang cập nhật dữ liệu...
                            </div>
                        )}

                    </div>
                </AnimatedPage>
            </div>

            {/* POPUP KIỂM TRA LỊCH SỬ CỦA USER */}
            {isShow && (
                <div className="b-modal-overlay">
                    <div className="b-modal-content" style={{padding: '0', overflow: 'hidden', display: 'flex', flexDirection: 'column'}}>
                        <div style={{background: '#f4f6f8', padding: '15px', fontWeight: 'bold', fontSize: '16px', textAlign: 'center', borderBottom: '1px solid #ddd'}}>
                            Lịch sử của <span style={{color: '#4caf50'}}>{popup?.[0]?.username || "Người dùng"}</span>
                            <div className="b-modal-close" onClick={() => setShow(false)}>
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                            </div>
                        </div>
                        <div style={{padding: '15px', maxHeight: '60vh', overflowY: 'auto'}}>
                            {popup && popup.length > 0 ? popup.map((item, idx) => (
                                <div key={idx} style={{border: '1px solid #eee', borderRadius: '8px', padding: '10px', marginBottom: '10px'}}>
                                    <div style={{fontWeight: 'bold', color: '#333', marginBottom: '5px'}}>
                                        Sảnh: {item.sanh === "3 phút" ? "Keno 3p" : item.sanh === "5 phút" ? "Keno 5p" : item.sanh === "1 phút" ? "Keno 1p" : item.sanh}
                                    </div>
                                    <div style={{fontSize: '13px', color: '#555', display: 'flex', justifyContent: 'space-between', marginBottom: '3px'}}>
                                        <span>Tiền cược:</span> <b>{Number(item.money).toLocaleString("vi-VN")}</b>
                                    </div>
                                    <div style={{fontSize: '13px', color: '#555', display: 'flex', justifyContent: 'space-between', marginBottom: '3px'}}>
                                        <span>Hoa hồng:</span> <b style={{color: '#e74c3c'}}>{Number(item.hoahong).toLocaleString("vi-VN")}</b>
                                    </div>
                                    <div style={{fontSize: '11px', color: '#999', textAlign: 'right', marginTop: '5px'}}>
                                        {formatDate(item.createdAt)}
                                    </div>
                                </div>
                            )) : <div style={{textAlign: 'center', color: '#888', padding: '20px 0'}}>Không có lịch sử cược</div>}
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
}

export default Invite;